import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { downloadFile, toISO8601 } from '@fortem-monorepo/js-utilities'
import { useApi } from '@fortem-monorepo/react-spa'
import { Misc } from '@fortem-monorepo/web-sdk'

export const useDownloadTimeSeriesMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: async (body: Misc.DownloadTimeSeriesBody) => {
      const data = await api.misc.timeSeries.downloadExcel(body)

      const filename = `time_series_${toISO8601(new Date())}.xlsx`

      downloadFile({
        fileData: data,
        filename,
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
    },
    onSuccess(_data, _variables, _onMutateResult, _context) {
      toast.success(`Download successful`)
    },
  })
}
